// @flow

require("./qr-code-box.scss");

// $FlowFixMe
var QRCode = require('qrcode');

import { $$ } from "utils/FakeQuery";

export class QRCodeBox{
    url: string | null;
    $container: $$;

    constructor(){
        this.url = null;

        this.$container = $$('<div tabindex="0" class="mm-ui qr-code-box"></div>');

        this.setUrl(null);
    }

    setUrl(url: string | null){
        this.url = url;
        this.render();
    }

    render (){
        this.$container.empty();
        //url = "https://bit.ly/IqT6zt";

        if( this.url ){
            this.$container.append( $$('<p class="text">Get map on phone</p>') );
            QRCode.toDataURL(this.url, { errorCorrectionLevel: 'L', margin: 1, scale: 12, color: {dark: '#000', light: '#fff'}, rendererOpts: {quality: 0.95} }, (err, dataURL) => {
                this.$container.append( $$('<div class="qr-code-image-wrapper"><img class="qr-code" src="'+ dataURL +'"></div>') );
            });
            this.$container.show();
        }else{
            this.$container.hide();
        }

        return this.$container.get(0);
    }
}


// WEBPACK FOOTER //
// src/kiosk/QRCodeBox/index.js